import styled from 'styled-components'
import { animated } from '@react-spring/web'

export const AnimationContainer = styled(animated.div)``
